import React from 'react'
import Form from '../../../components/Form'
import fields, { UserCreateFormData } from './fields'
import { toast } from 'react-toastify'
import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import { useHistory } from 'react-router-dom'
import routes from '../../../config/routes'

interface Props {
}

const UserCreateForm: React.FC<Props> = () => {
  const { request } = useRequest()
  const history = useHistory()

  return (
    <Form<UserCreateFormData>
      buttonLabel="SALVAR"
      fields={fields}
      onSubmit={data => {
        const dataSend = { ...data,  cpf: data.cpf ? data.cpf.split('.').join('').split('-').join('').split('/').join(''): ''  }
        return handleFormSubmit({
          request: request({
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/users/create`,
            data: dataSend,
          }),
          onValidationErrors: () => toast.error('Erros de validacao.'),
          onSuccess: ({ data }) => {
            toast.success('Usuário cadastrado com sucesso.')
            history.push(routes.admin.user.show.pathFor(data.data.id))
          },
          onFailure: () => toast.error('Erro ao alterar informações.'),
        })
      }}
    />
  )
}

export default UserCreateForm
